import api from '../api';

const extractValue = (response) => (response && response.data && response.data.value) || {};

const findCatalog = async (requestId, responsibleId) =>
    api.get({ type: 'user', service: `requests/${requestId}/members/${responsibleId}/price-adjustments/catalog` })
        .then(extractValue);

const applyAdjustment = async (requestId, responsibleId, adjustment) =>
    api.post({
        type: 'user',
        service: `requests/${requestId}/members/${responsibleId}/price-adjustments`,
        data: adjustment
    }).then(extractValue);

const revertAdjustment = async (requestId, adjustmentId, reversal) =>
    api.post({
        type: 'user',
        service: `requests/${requestId}/members/price-adjustments/${adjustmentId}/revert`,
        data: reversal
    }).then(extractValue);

const faciliterAdjustmentService = {
    findCatalog,
    applyAdjustment,
    revertAdjustment
}

export default faciliterAdjustmentService;
